<template>
  <div :class="$style.error">
    <img
      @click="$store.commit('resetError')"
      :class="$style.cross"
      src="/icons/white-cross.svg"
      alt=""
    />
    <div v-if="errors.length > 0" :class="$style.errors">
      <div v-for="item in errors" :key="item">{{ item }}</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    errors() {
      return this.$store.state.errors.errors;
    },
  },
};
</script>

<style lang="scss" module>
.error {
  position: fixed;
  bottom: 0.25rem;
  right: 0.25rem;
  background-color: $red-primary;
  z-index: 50;
  color: $t-white;
  padding: 2rem 1rem;
  width: 22rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  .errors {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .cross {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    cursor: pointer;
  }
}
</style>
